import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom'

function ShowUsers() {
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [userPermissions, setUserPermissions] = useState([]);
    const [message, setMessage] = useState('');
    const [rerender, setRerender] = useState(false);
    const componentMounted = useRef(true);

    useEffect(() => {
        let interval;
        const fetchData = async () => {
            setLoading(true)
            try {
                if (componentMounted.current) {
                    interval = setInterval(async () => {
                        const { data } = await axios.get(
                            `${process.env.REACT_APP_BACKLINK}/api/private/show-users`,
                            { withCredentials: true }
                        );
                        setUsers(data.users);
                        setUserPermissions(data.permissions);
                    }, 2000);
                    setLoading(false)
                }

            } catch (error) {
                setError(error.response.msg);
            }
        };
        fetchData()


        return () => {
            componentMounted.current = false;
            clearInterval(interval);
        }
    }, []);


    const deleteUser = async (id) => {
        try {
            await axios.delete(
                `${process.env.REACT_APP_BACKLINK}/api/private/delete-user/${id}`
                ,
                { withCredentials: true }
            );
            setTimeout(() => {
                setMessage('')
            }, 5000)
            setMessage('Successfully Deleted')
            setRerender(!rerender);
        } catch (error) {
            setError(error.response.msg)
        }
    }
    return (
        <>
            {loading ? <h1>Loading...</h1> :

                <div>
                    {error && (
                        <span className="error-message">{error}</span>
                    )}
                    <h1>{message}</h1>
                    <Link to={'/add-user'} className="btn btn-success float-right">Add User</Link>

                    <div className="card-body table-responsive p-0">
                        <table className="table text-nowrap">
                            <thead>

                                <tr>
                                    <th>Username</th>
                                    <th>Role</th>
                                    <th>LoggedIn?</th>
                                    <th>Email</th>
                                    <th>Profile Image</th>
                                    <th>Do What?</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.map(user => (
                                    <tr key={user.id}>
                                        <td>{user.username}</td>
                                        <td>{user.role}</td>
                                        <td>{user.loggedIn === true ? <div className='log on'></div> : <div className='log off'></div>}</td>
                                        <td>{user.email}</td>
                                        <td>
                                            <img
                                                src={
                                                    user.profileImage === 'null' ?
                                                        (`/uploads/no-image.png`) :
                                                        user.profileImage === '' ?
                                                            (`/uploads/no-image.png`) :
                                                            (`/uploads/${user.profileImage}`)}
                                                alt="profile-avatar"
                                                className='show-users-image'
                                            />
                                        </td>

                                        <td>
                                            <Link
                                                to={`/update-user/${user.id}`}
                                                className='btn btn-primary mr-3'
                                            >
                                                Update
                                            </Link>

                                            {userPermissions.includes('/delete-user/:id') && (
                                                <button
                                                    onClick={() => deleteUser(user.id)}
                                                    className='btn btn-danger'
                                                >
                                                    Delete
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>

                </div>
            }
        </>
    )
}

export default ShowUsers
